document.getElementById('klaviyo-footer-form').addEventListener('submit',     
  function(e) {                                                                 
    e.preventDefault();                                                         
    var email = document.getElementById('klaviyo-email-input').value;           
    var msg = document.getElementById('klaviyo-form-message');                  
    var btn = this.querySelector('button');                                     
    btn.disabled = true;                                                        
                                                                                
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QSc5zg', {    
      method: 'POST',                                                           
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({                                                    
        data: {                                                                 
          type: 'subscription',                                                 
          attributes: { profile: { data: { type: 'profile', attributes: { email:
   email } } }, custom_source: 'Footer Signup' },                               
          relationships: { list: { data: { type: 'list', id: 'UNa82a' } } }     
        }                                                                       
      })                                                                        
    }).then(function(r) {                                                       
      if (r.ok || r.status === 202) {                                           
        msg.textContent = 'Welcome to the GREEN Tribe!';                        
        msg.style.display = 'block';                                            
        document.getElementById('klaviyo-email-input').value = '';              
      } else { throw new Error(); }                                             
    }).catch(function() {                                                       
      msg.textContent = 'Something went wrong. Please try again.';              
      msg.style.display = 'block';                                              
    }).finally(function() {                                                     
      btn.disabled = false;                                                     
      setTimeout(function() { msg.style.display = 'none'; }, 5000);             
    });                                                                         
  });